import {REHYDRATE} from 'redux-persist';

const initialState = {
  yieldEstimatorLatitude: 0,
  yieldEstimatorLongitude: 0,
  plantPopulation: 32000,
  kernelsPerBushel: 80000,
  ears: [
    {rows: 0, length: 0},
    {rows: 0, length: 0},
    {rows: 0, length: 0},
    {rows: 0, length: 0},
  ],
  calculatedYield: 0,
  yieldEstimatorFileToUpload: null,
  yieldEstimatorGrowerIdOverride: '',
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.toolBox,
          yieldEstimatorLatitude: 0,
          yieldEstimatorLongitude: 0,
          plantPopulation: 32000,
          kernelsPerBushel: 80000,
          ears: [
            {rows: 0, length: 0},
            {rows: 0, length: 0},
            {rows: 0, length: 0},
            {rows: 0, length: 0},
          ],
          calculatedYield: 0,
          yieldEstimatorFileToUpload: null,
          yieldEstimatorGrowerIdOverride: '',
        };
      }
      return state;

    case 'INIT_YIELD_ESTIMATOR_INTERFACE':
      return {
        ...state,
        yieldEstimatorLatitude: 0,
        yieldEstimatorLongitude: 0,
        plantPopulation: 32000,
        kernelsPerBushel: 80000,
        ears: [
          {rows: 0, length: 0},
          {rows: 0, length: 0},
          {rows: 0, length: 0},
          {rows: 0, length: 0},
        ],
        calculatedYield: 0,
        yieldEstimatorFileToUpload: null,
        yieldEstimatorGrowerIdOverride: '',
      };

    case 'SET_YIELD_ESTIMATOR_GEOLOCATION':
      return {
        ...state,
        yieldEstimatorLatitude: action.latitude,
        yieldEstimatorLongitude: action.longitude,
      };

    case 'SET_YIELD_ESTIMATOR_PLANT_POPULATION':
      return {
        ...state,
        plantPopulation: action.plantPopulation,
      };

    case 'SET_YIELD_ESTIMATOR_KERNELS_PER_BUSHEL':
      return {
        ...state,
        kernelsPerBushel: action.kernelsPerBushel,
      };

    case 'SET_YIELD_ESTIMATOR_EARS_ROWS':
      state.ears[action.index].rows = action.rows;
      return {
        ...state,
        ears: [...state.ears],
      };

    case 'SET_YIELD_ESTIMATOR_EARS_LENGTH':
      state.ears[action.index].length = action.length;
      return {
        ...state,
        ears: [...state.ears],
      };

    case 'SET_YIELD_ESTIMATOR_FILE_TO_UPLOAD':
      return {
        ...state,
        yieldEstimatorFileToUpload: action.file,
        };

    case 'SET_YIELD_ESTIMATOR_CALCULATED_YIELD':
      return {
        ...state,
        calculatedYield: action.calculatedYield,
      };

    case 'SET_YIELD_ESTIMATOR_GROWER_ID_OVERRIDE':
      return {
        ...state,
        yieldEstimatorGrowerIdOverride: action.growerId,
      };
      
    default:
      return state;
  }
}
